import { produce } from 'immer';

import { DepartmentTemplate } from '../../models';
import { ActionType } from './types';

export interface IDepartment {
  id: string;
  name: string;
}

export interface DepartmentTemplatesState {
  all: DepartmentTemplate[];
  isLoading: boolean;
  isAddEditLoading: boolean;
  isDuplicateLoading: boolean;
  isCreateLoading: boolean;
  isUpdateLoading: boolean;
  isDeleteLoading: boolean;
  serverError: string;
  departmentId: string;
}

const initialState = {
  all: [],
  isLoading: false,
  isAddEditLoading: false,
  isDuplicateLoading: false,
  isCreateLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  serverError: null,
  departmentId: null,
};

const departmentTemplates = produce((draft: DepartmentTemplatesState, action) => {
  const { payload, error } = action;
  switch (action.type) {
    case ActionType.GET_DEPARTMENT_TEMPLATES:
      draft.isLoading = true;
      break;
    case ActionType.GET_DEPARTMENT_TEMPLATES_FULFILLED:
      draft.isLoading = false;
      draft.all = payload?.data;
      break;
    case ActionType.GET_DEPARTMENT_TEMPLATES_REJECTED:
      draft.serverError = error.message;
      draft.isLoading = false;
      break;
    case ActionType.ADD_DEPARTMENT_TEMPLATE:
    case ActionType.EDIT_DEPARTMENT_TEMPLATE:
      draft.isAddEditLoading = true;
      break;
    case ActionType.ADD_DEPARTMENT_TEMPLATE_FULFILLED:
    case ActionType.EDIT_DEPARTMENT_TEMPLATE_FULFILLED:
      draft.isAddEditLoading = false;
      break;
    case ActionType.ADD_DEPARTMENT_TEMPLATE_REJECTED:
    case ActionType.EDIT_DEPARTMENT_TEMPLATE_REJECTED:
      draft.serverError = error.message;
      draft.isAddEditLoading = false;
      break;
    case ActionType.DELETE_DEPARTMENT_TEMPLATE:
      draft.isDeleteLoading = true;
      break;
    case ActionType.DELETE_DEPARTMENT_TEMPLATE_FULFILLED:
      draft.isDeleteLoading = false;
      break;
    case ActionType.DELETE_DEPARTMENT_TEMPLATE_REJECTED:
      draft.serverError = error.message;
      draft.isDeleteLoading = false;
      break;
    case ActionType.SET_ACTIVE_DEPARTMENT:
      draft.departmentId = payload?.id;
      break;
  }
}, initialState);

export default departmentTemplates;
